/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Value_Source_Document_ViewInputs */

const en_case_value_source_document_view = /** @type {(inputs: Case_Value_Source_Document_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View source document`)
};

const pt_br2_case_value_source_document_view = /** @type {(inputs: Case_Value_Source_Document_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver documento fonte`)
};

/**
* | output |
* | --- |
* | "View source document" |
*
* @param {Case_Value_Source_Document_ViewInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_value_source_document_view = /** @type {((inputs?: Case_Value_Source_Document_ViewInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Value_Source_Document_ViewInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_value_source_document_view(inputs)
	return pt_br2_case_value_source_document_view(inputs)
});